(function () {
    'use strict';

    angular
        .module('app.reCrawlPosts')
        .factory('reCrawlPostsService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function reCrawlPosts(limit, offset, loader) {
                    var url_reCrawlPosts = $rootScope.apiUrl + 'crawler/reCrawlPosts?limit=' + limit + '&offset=' + offset;
                    return handleRequest(url_reCrawlPosts, 'GET', null, loader);
                }

                service.reCrawlPosts = reCrawlPosts;
                return service;
            }
        ]);
})();
